/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.27",
    versionName: "0.2.0-nightly.2025.7.27",
    versionChannel: "nightly",
    buildDate: "2025-07-27T00:08:40.013Z",
    commitHash: "d3a41703a1c7c55e70564e75edd52f5be2beadfa",
};
